import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=66860af5&scoped=true&"
import script from "./Surveys.vue?vue&type=script&lang=js&"
export * from "./Surveys.vue?vue&type=script&lang=js&"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=66860af5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66860af5",
  null
  
)

export default component.exports